(function () {
    'use strict';

    angular.module("imApp").factory("textileModelCategory8LangService", ['$ihttp', function ($ihttp) {
        let service = {
            listTextileModelCategory8Languages: function (parms) {
                return $ihttp.post({
                    method: 2703,
                    parameters: parms || {}
                });
            },
            saveObj: function (edit) {
                return $ihttp.post({
                    method: 2704,
                    parameters: edit
                });
            }
        };

        return service;
    }]);
})();
